
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sunpoint",
      function () {
        return require("private-next-pages/sunpoint/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sunpoint"])
      });
    }
  